var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"rel":"nofollow"},on:{"click":function($event){return _vm.$emit('set-location', _vm.item)}}},[_vm._v(_vm._s(_vm.item.city))])])}
var staticRenderFns = []

export { render, staticRenderFns }